import React from "react"

const TrackerTemplate = ({ portfolio, trackerTemplate }) => {
  const urlHost = window.location.origin

  return <>
    <tr className='border-t border-gray-400 even:bg-gray-200'>
      <td className='px-2 py-3 w-1/6'>{trackerTemplate.name}</td>
      <td className='px-2 py-3'>{`${urlHost}/api/portfolios/${portfolio.id}/trackers/${trackerTemplate.slug}/geo_json.geojson`}</td>
      <td className='px-2 py-3'>{`${urlHost}/api/portfolios/${portfolio.id}/trackers/${trackerTemplate.slug}.json`}</td>
    </tr>
  </>
}

export default TrackerTemplate
